import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../../../theme/modern/tokens"
import {COARSE, TOUCH_MIN} from "../../../../../theme/modern/touchTargets"

/** Ported from `record.css` `.sect` / `.pt-grid` / `.ptc` / `.clinical-link`. */
export default makeStyles((theme: ModernTheme) => ({
    sect: {
        background: theme.modern.panel,
        border: `1px solid ${theme.modern.line}`,
        borderRadius: 12,
        padding: "9px 12px",
        boxShadow: theme.modern.shadow,
        display: "flex",
        flexDirection: "column",
        minWidth: 0,
        minHeight: 0,
        overflow: "auto",
    },
    sect_head: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "8px",
        marginBottom: 6,
    },
    microlabel: {
        font: `600 10px/1 ${theme.modern.sans}`,
        letterSpacing: ".12em",
        textTransform: "uppercase",
        color: theme.modern.ink2,
    },
    pill: {
        font: `500 10.5px ${theme.modern.mono}`,
        padding: "2.5px 8px",
        borderRadius: 99,
        background: theme.modern.panel2,
        border: `1px solid ${theme.modern.line}`,
        color: theme.modern.ink2,
        whiteSpace: "nowrap",
    },

    grid: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "3px 16px",
        marginTop: 4,

        "@media (max-width:720px)": {gridTemplateColumns: "1fr"},
    },
    row: {
        display: "flex",
        alignItems: "baseline",
        justifyContent: "space-between",
        gap: "8px",
        padding: "3px 0",
        borderBottom: `1px solid ${theme.modern.line2}`,
        minWidth: 0,
    },
    row_label: {
        font: `500 11px ${theme.modern.sans}`,
        color: theme.modern.ink2,
        whiteSpace: "nowrap",
        flex: "none",
    },
    // long IDs and names truncate; the full value stays reachable via title
    row_value: {
        font: `600 12px ${theme.modern.mono}`,
        color: theme.modern.ink,
        textAlign: "right",
        whiteSpace: "nowrap",
        minWidth: 0,
        flex: "1 1 auto",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },

    clinical_link: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        marginTop: 7,
        padding: "6px 14px",
        borderRadius: 8,
        font: `600 12px ${theme.modern.sans}`,
        color: theme.modern.accent,
        background: theme.modern.accentSoft,
        border: `1px solid ${theme.modern.accentLine}`,
        alignSelf: "flex-start",
        cursor: "pointer",

        "& svg": {width: 13, height: 13, flex: "none"},

        "&:hover": {filter: "brightness(.97)"},
        "&:active": {filter: "brightness(.93)"},

        // opens the clinical-info dialog, and with the keys bar hidden below
        // 820 px this button is the only way in — the "O" shortcut needs a
        // keyboard the tablet does not have
        [COARSE]: {minHeight: TOUCH_MIN, padding: "0 16px"},
    },
}))
